<template>
  <div class="">
    <block-title title="Map" class="mb-0" />
    <sunburst-graph
      class="max-w-lg"
      :data="parsedData"
      :node-id="selectedActorID"
    >
    </sunburst-graph>
  </div>
</template>

<script>
import BlockTitle from '@/components/landscape/info/BlockTitle'
import {mapGetters} from 'vuex'
import SunburstGraph from '@/components/viz/SunburstGraph.vue'

export default {
  name: 'LandscapeMap',
  components: {
    BlockTitle,
    SunburstGraph
  },

  data() {
    return {
      parsedData: null
    }
  },
  computed: mapGetters([
    'currentLandscape',
    'selectedActorID',
    'selectedActor'
  ]),
  watch: {
    currentLandscape: function() {
      this.prepareData()
    },
    selectedActor: function() {
      // console.log('selectedActor CHANGED')
      // Sunburst.api.gotoActor(this.selectedActor.id)
    }
  },
  mounted() {
    if (this.currentLandscape) {
      this.prepareData()
    }
  },
  methods: {
    setSizes: function(node, size) {
      node.children = node.actors
      if (node.children && node.children.length > 0) {
        let l = node.children.length
        for (let i in node.children) {
          let child = node.children[i]
          this.setSizes(child, size / l)
        }
      } else {
        node.size = size
      }
      return node
    },
    prepareData: function() {
      let data = JSON.parse(JSON.stringify(this.currentLandscape))
      this.parsedData = this.setSizes(data, 1)
    }
  }
}
</script>
